module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }